// Tailwind-style slate ramp, 25-step notation
const aquanowSlate = {
    '25':  '#fafbfc',   // custom tint (≈ +98 % L)
    '50':  '#f8fafc',   // slate-50
    '100': '#f1f5f9',   // slate-100
    '150': '#e9edf3',   // custom tint
    '200': '#e2e8f0',   // slate-200
    '250': '#d8dee7',   // custom tint
    '300': '#cbd5e1',   // slate-300
    '350': '#b1bccf',   // custom tint
    '400': '#94a3b8',   // slate-400
    '450': '#8695ac',   // custom shade
    '500': '#64748b',   // slate-500
    '550': '#566778',   // custom shade
    '600': '#475569',   // slate-600
    '650': '#3d495d',   // custom shade
    '700': '#334155',   // slate-700
    '750': '#2b3549',   // custom shade
    '800': '#1e293b',   // slate-800
    '850': '#182232',   // custom shade
    '900': '#0f172a',   // slate-900   ← Tailwind bg-slate-900
    '950': '#020617',   // slate-950
    '975': '#01040e',   // custom shade (≈ −90 % L)
};

export default aquanowSlate;
  